import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  formatBall,
  formatDrawId,
  formatMoney,
  GAME_META,
  GAME_POWER,
  WEEKDAYS_VN,
} from "./constants";

dayjs.extend(utc);

function MatchDots({ count, specialLast = false }) {
  return (
    <span className="vietlott-dots" aria-hidden>
      {Array.from({ length: count }, (_, i) => (
        <i
          key={i}
          className={specialLast && i === count - 1 ? "vietlott-dot is-special" : "vietlott-dot"}
        />
      ))}
    </span>
  );
}

function Money({ value }) {
  return (
    <span className="vietlott-money">
      {formatMoney(value)}
      <sup>đ</sup>
    </span>
  );
}

export default function VietlottResultCard({ result }) {
  if (!result) return null;
  const meta = GAME_META[result.game];
  if (!meta) return null;

  const draw = /^\d{4}-\d{2}-\d{2}$/.test(String(result.drawDate || ""))
    ? dayjs(result.drawDate)
    : dayjs.utc(result.drawDate);
  const dateLabel = draw.isValid() ? draw.format("DD/MM/YYYY") : "";
  const weekday = draw.isValid() ? WEEKDAYS_VN[draw.day()] : "";
  const numbers = [...(result.numbers || [])].sort((a, b) => a - b);
  const isPower = result.game === GAME_POWER;
  const prizes = result.prizes || {};

  return (
    <section className={`vietlott-card${isPower ? " is-power" : ""}`}>
      <div className="vietlott-card__title">
        KẾT QUẢ XỔ SỐ <span className="vietlott-card__product">{meta.title}</span>
        {dateLabel ? ` - NGÀY: ${dateLabel}` : ""}
      </div>

      <div className="vietlott-card__meta">
        <span>{weekday}</span>
        <span>
          Kỳ vé: {formatDrawId(result.drawId)}
          {dateLabel ? ` | Ngày quay thưởng ${dateLabel}` : ""}
        </span>
      </div>

      <ul className={`vietlott-balls${isPower ? " has-bonus" : ""}`}>
        {numbers.map((n, i) => (
          <li key={`${n}-${i}`} className="vietlott-ball">
            {formatBall(n)}
          </li>
        ))}
        {isPower && result.bonusNumber != null ? (
          <li className="vietlott-ball is-special">{formatBall(result.bonusNumber)}</li>
        ) : null}
      </ul>

      <table className="vietlott-prizes">
        <thead>
          <tr>
            <th>Giải thưởng</th>
            <th>Trùng khớp</th>
            <th>Số lượng giải</th>
            <th>Giá trị giải (đồng)</th>
          </tr>
        </thead>
        <tbody>
          {meta.prizeRows.map((row) => {
            const prize = prizes[row.key] || {};
            return (
              <tr key={row.key}>
                <td className="vietlott-prizes__name">{row.label}</td>
                <td>
                  <MatchDots count={row.matches} specialLast={row.specialLast} />
                </td>
                <td>{prize.winners != null ? formatMoney(prize.winners) : "—"}</td>
                <td className="vietlott-prizes__amount">
                  <Money value={prize.amount} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
}
